import './i18n.js';

/**
 * Import blocks
 */
 import './blocks/schedule-content-block';